import serviceRequest from "utils/request";

const baseUrl = "/org";

export const getOrganizationList = (params) => {
	return serviceRequest({
		url: `${baseUrl}/organization-list`,
		method: "get",
		params,
	});
};

export const getOrganizationListNotLogin = (data) => {
	return serviceRequest({
		url: `${baseUrl}/organization-list-for-not-login`,
		method: "post",
		data,
	});
};

export const getApprovedOrganizationList = (params) => {
	return serviceRequest({
		url: `${baseUrl}/get-available-orgs-by-approver`,
		method: "get",
		params,
	});
};

export const getUserOrganizationList = (params) => {
	return serviceRequest({
		url: `api/user/organization-list`,
		method: "get",
		params,
	});
};

export const getUserInfoByEmail = (params) => {
	return serviceRequest({
		url: `api/user/get-user-info-by-email`,
		method: "get",
		params,
	});
};
